

// object to store loaded CSS chunks
var installedCssChunks = {
	826: 0
}
__webpack_require__.f.compat = (chunkId, promises) => {


	// mini-css-extract-plugin CSS loading
	var cssChunks = {"120":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
			var href = "" + {"18":"659a32a47320d9f0d114","34":"7b73a723ce7de2c72ff9","37":"b5525712af52de0fdf8d","88":"20d50cf46a422f98e977","119":"7aeec19e863bed15926e","120":"c5aa3dc80be35f678d3c","159":"8a9a1ff79afb3753d581","340":"84a509fc9f2826e412bf","346":"6c83b70ee1ae885c3b9a","362":"c4d71c492f19d78352c6","373":"cf437a841c06289b437b","378":"b9f9efb763b5c24776fb","406":"fca0b440a33e647419b8","408":"1f53ded062f07c9818ee","413":"e7ca8f8769b2b63871c5","422":"c9a59e7dcbb206b6e8be","459":"a0271dfb49068027fa34","464":"2918f0ae38525e3cca79","495":"dad5311ae2adf8113530","557":"82caf9bb5353f8681996","578":"664494d6ee7bee63fd4d","586":"5564c8d37588cab9d037","603":"e6c809b42a028d09bde9","737":"72b4e4b6f15a2dda516e","770":"83fde96a4f3a2f827464","781":"11e87a8a08461ba8439c","786":"c474dccac8297591e4a9","827":"27164e0df249631e9ba8","831":"cee83b52efc40d88b6bb","845":"2bd59a806ca82b261744","848":"1c62b29d5f34bd1c0050","850":"98a3e46dcdae9c1384cd","863":"e76b8aa6ed2de9fe2bed","877":"b3bac4eeb17ed56fe173","894":"6515ec87a464d24aa1ba","897":"e1634c6cc6e6dd8b51dd","912":"ba6448ff938a35d1c53f","942":"20a9e65976f58d17a4d4","970":"8c40edcccc231388d3bd"}[chunkId] + "/style.css";
			var fullhref = __webpack_require__.p + href;
			var existingLinkTags = document.getElementsByTagName("link");
			for(var i = 0; i < existingLinkTags.length; i++) {
				var tag = existingLinkTags[i];
				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
				if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
			}
			var existingStyleTags = document.getElementsByTagName("style");
			for(var i = 0; i < existingStyleTags.length; i++) {
				var tag = existingStyleTags[i];
				var dataHref = tag.getAttribute("data-href");
				if(dataHref === href || dataHref === fullhref) return resolve();
			}
			var linkTag = document.createElement("link");
			linkTag.rel = "stylesheet";
			linkTag.type = "text/css";
			linkTag.onload = resolve;
			linkTag.onerror = function(event) {
				var request = event && event.target && event.target.src || fullhref;
				var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
				err.request = request;
				delete installedCssChunks[chunkId]
				linkTag.parentNode.removeChild(linkTag)
				reject(err);
			};
			linkTag.href = fullhref;
			var head = document.getElementsByTagName("head")[0];
			head.appendChild(linkTag);
		}).then(function() {
			installedCssChunks[chunkId] = 0;
		}));
	}
};